import { render, staticRenderFns } from "./FormRadioCustom.vue?vue&type=template&id=42475d3e"
import script from "./FormRadioCustom.vue?vue&type=script&lang=js"
export * from "./FormRadioCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports